/// amarildo lacerda
///
/// exemplo:   
///
//<mat-datagrid name="table" 
//   [(value)]="funils" 
//   filterText="Filtrar o funil" 
//   editable=true 
//   showEditButton = true
//   filtered 
//   matSort 
//   [(columns)]="colunas"
//   [innerFilter]=getFilterAttrib()
//   pageSize=15 
//   paginated = true
//   [elevation] = true;
//   (onDialog)="abrirDialog($event)";
//   (click)="doClick($event)" (editItem)="doEditItem($event)">
//</mat-datagrid>


import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, forwardRef, ViewChild, Inject, NgModule, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
//import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, Sort, PageEvent, MatInput, MatPaginatorIntl } from '@angular/material';
import { MatTableDataSource, MatSort, MatPaginator, MatDialogContainer, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
//import { COMPONENT_VARIABLE } from '@angular/platform-browser/src/dom/dom_renderer';
//import { debounceTime } from 'rxjs/operators';
//import { Observable, BehaviorSubject, OperatorFunction } from 'rxjs'



export interface DataGridColumn {
    field: string;
    text?: string;
    rows?: number;
    cols?: number;
    color?: string;
    visible?: boolean;
    actions?: boolean;
    width: number;
    type?: string;
    fn?: Function;
}


@Component({
    selector: 'mat-datagrid',
    styles: [`:host { display: block; }`, `mat-toolbar{ font-size:14px;}`],
    template: `<div>
<!-- barra de titulo -->
<div fxLayout="column">
<div>
   <mat-toolbar *ngIf="title>''">
    <div fxFlex>{{title}}</div>
    <button fxLayoutAlign="end center"  mat-icon-button  *ngIf="(!editing) && (title!='')" (click)="doAddItem()">
       <mat-icon>add</mat-icon><span fxHide.lt-lg>{{checkDense('Novo')}}</span>
    </button> 
</mat-toolbar>
<div id="innerHeader" [innerHtml]="innerHeader" fxLayoutAlign="none center">
</div>

</div><div>
<div fxFlex fxLayout="row" fxLayoutGap="5px">
<div fxFlex fxLayout="row" fxLayoutAlign="none center" fxLayoutGap="10px">
   <mat-form-field *ngIf="filtered">
        <input  [disabled]="editing" ngModel [(ngModel)]="inputSearchText"  matInput (keyup)="doFilter()" placeholder="{{filterText}}">
   </mat-form-field>
   <div><ng-content></ng-content></div>
  </div>

  <div *ngIf="hasCheckFilter()" fxLayoutAlign="end center"> 
     <form>
      <mat-checkbox name="chckFilter" (change)="doCheckFilter($event)" [(ngModel)]="checkFilterValue"  value="false" color="primary" [ngModelOptions]="{standalone: true}"></mat-checkbox>
     </form> 
     </div>
     <div id="innerFilter" fxLayoutAlign="end center" [innerHtml]="innerFilter">
 </div>

 <div fxLayoutAlign="end center" *ngIf="isEmpty() || showEditButton" > 
   <button  mat-icon-button  *ngIf="(!editing) && (title=='')" (click)="doAddItem()">
      <mat-icon>add</mat-icon> <span fxHide.lt-lg>{{checkDense('Novo')}}</span>
   </button> 
   </div> 
</div>
</div>
<!-- tabela -->
<mat-table dense class="matTable" matSort  
  *ngIf="loaded" #table [dataSource]="dataSource" 
  [ngClass]="{'mat-elevation-z8':elevation}" 
  (matSortChange)="sortData($event)">
  
  <!-- titulo das colunas da tabela -->
  <ng-container 
            *ngFor="let item of titleColumns; 
                    let i = index;" 
            matColumnDef="{{item.field}}">
            
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span  *ngIf="isDataColumn(item.field)"> 

            <p *ngIf="hasInfo(item)"
                [matTooltip]="getInfo(item)">
                {{item.text}}
            </p>
            
          <div *ngIf="!hasInfo(item)">
             {{item.text}}
          </div>

            
            
            </span>
            <button mat-icon-button  *ngIf="((inEditorLine) && !editing && !isDataColumn(item.field))  && (!showEditButton)" (click)="doInsertItem($event)">
              <mat-icon>add</mat-icon> <span fxHide.lt-lg>{{checkDense('Novo')}}</span>
            </button>  
            <span *ngIf="(dataChanges.length>0) && !isDataColumn(item.field)">
            <button mat-icon-button   (click)="doApplyItems($event)">
              <mat-icon>done_all</mat-icon> {{checkDense('ok')}}
            </button>
            <button mat-icon-button (click)="doCancelAll()">
              <mat-icon>autorenew</mat-icon> {{checkDense('rec')}}
              </button>
            </span>  
        </mat-header-cell>

<!-- linhas da tabela -->

        <mat-cell *matCellDef="let row">
        <span *ngIf="isDataColumn(item.field,item)">
           <span 
             *ngIf="(row.index!=selectedRowIndex)">
                  <span *ngIf="isIcon(item)">
                    <mat-icon class="mat-18">{{getFieldValue(row,i)}}</mat-icon>
                  </span>
                  <span *ngIf="isText(item)"> 
                    {{getFieldValue(row,i)}}
                 </span> 
            </span>
            <div fxFlex
               fxLayout="column" 
               *ngIf="editing && (row.index==selectedRowIndex)">
               <div>
                  <mat-form-field>
                    <input matInput 
                       name="currentRow[item.field]" 
                       value="{{getFieldValue(row,i)}}"
                       placeholder={{item.text}} /> 
                  </mat-form-field>
                </div>
            </div>
          </span>
          <span fxFlex fxLayout="row" 
             fxLayoutAlign="center center"
             fxLayoutGap="1px" 
             *ngIf="(inEditorLine || showEditButton) && editable && (!isDataColumn(item.field,item))">
             <div  id="innerRows-{{item.field}}" [innerHtml]="innerRows"></div>
             <button mat-icon-button *ngIf="!editing || showEditButton" (click)="doEditItem(row)"> <mat-icon>edit</mat-icon> <span fxHide.lt-lg>{{checkDense('Alt')}}</span> </button> 
             <button mat-icon-button *ngIf=" !showEditButton && editing && (row.index==selectedRowIndex)" (click)="doPostItem(row)"> <mat-icon>save</mat-icon> <span fxHide.lt-lg>{{checkDense('Ok')}}</span> </button> 
             <button mat-icon-button *ngIf="!editing && showEditButton && canDelete(row)" (click)="doDeleteItem(row)"> <mat-icon>delete</mat-icon> <span fxHide.lt-lg>{{checkDense('Exc')}}</span> </button> 
             <button mat-icon-button *ngIf="!showEditButton && editing  && (row.index==selectedRowIndex)" (click)="doCancelItem(row)"> <mat-icon>cancel</mat-icon> <span fxHide.lt-lg>{{checkDense('Canc')}}</span> </button> 
             <button mat-icon-button *ngIf="hasSelectedEvent()" (click)="doSelectedEvent(row)"> <mat-icon>book</mat-icon> <span fxHide.lt-lg>{{checkDense('Lista')}}</span>  </button> 
          </span> 
        </mat-cell>
      
    </ng-container>
 <!-- links com o datasource -->   
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row;let x=index; columns: displayedColumns;"
        [ngClass]="{'highlight': selectedRowIndex == row.id}"
        (click)="doClick($event)">
    </mat-row>
</mat-table>

<div id="innerFooter" [innerHtml]="innerFooter" fxLayoutAlign="none center">
</div>
<!-- paginação -->
<span *ngIf="paginatorShow">
<mat-paginator *ngIf="paginated && (!editing) "  [ngClass]="{'mat-elevation-z8':elevation}"  
    [length]="pageLenght"
    [pageSize]="pageSize"
    [hidePageSize]="editing || hidePageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event">
</mat-paginator></span></div>

</div>
`,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MatDataGridComponent),
            multi: true
        }
    ]

})



export class MatDataGridComponent implements ControlValueAccessor, OnInit {
    currentRow: any;
    maxIndex: number = -1;
    clicked: boolean = false;
    dataOrigem: Array<any>;
    data: Array<any>;
    dataFilter: boolean = false;
    dataSorted: boolean = true;
    dataEditing: boolean = false;
    inEditorLine: boolean = false;
    selectedRowIndex: number = -1;
    dataChanges: any[] = [];
    localCheckFilter: boolean = false;
    felevation: boolean = true;
    private _enableClientFilter: boolean = true;
    private inputSearchText: string = ''
    @Output() inputKeyUpEnd = new EventEmitter<string>()
    private inputKeyUpTimeOutId = null
    @Input()
    get elevation() {
        return this.felevation;
    }
    set elevation(x) {
        this.felevation = x;
    }
    @Input() filterText: string = "Filtro";
    @Input() paginated: boolean = true;
    @Input() pageLenght: number = 100;
    @Input() alwaysShowPaginator = false
    @Input() hidePageSize = false
    @Output() pageChange = new EventEmitter<any>()
    fpageSize: number = 5;
    @Input()
    get pageSize(): number {
        return this.fpageSize;
    }
    set pageSize(x: number) {
        this.fpageSize = x;
    }
    @Input() pageSizeOptions: Array<number> = [1, 5, 10, 25, 50, 100];
    @Input() editable: boolean = false;
    @Input() tableName: string;
    @Input() title: string;
    @Input() showEditButton: boolean = true;
    @Input() innerFilter: string = "";
    @Input() innerRows: string = "";
    @Input() innerFooter: string = "";
    @Input() innerHeader: string = "";
    @Input() inativos: boolean = false;
    @Input() oldPageIndex: number;
    @Input() rowHeight: number = 40;
    @Input() dense: boolean;
    //private _enableClientFilter = true
    checkDense(c): string {
        return (this.dense ? '' : c);
    }
    paginatorShow: boolean = true;

    @Input()
    get pageIndex() {
        if (this.paginator) {
            return this.paginator.pageIndex
        }
        else
            return 0;
    }
    set pageIndex(x) {
        this.oldPageIndex = x;
        if (this.paginator)
            this.paginator.pageIndex = x;
    }

    fPageEvent: PageEvent;
    get pageEvent() {
        return this.fPageEvent;
    }
    set pageEvent(x) {
        this.fPageEvent = x;
        if (x) {
            this.oldPageIndex = x.pageIndex;
        }
        this.pageChange.emit(this.fPageEvent)
    }

    displayedColumns: Array<string> = [];
    dataSource = new MatTableDataSource<Element>([]);
    loaded: boolean = false;

    @Input()
    titleColumns: Array<DataGridColumn> = [];


    @Output()
    checkFilter: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    constructor(private ref: ChangeDetectorRef, public dialog: MatDialog) {
    }

    ngOnInit() {
        this.dataSource.sort = this.sort;
        if (this.tableName != null) {
            let c = window.localStorage.getItem(this.tableName + '_changes');
            if (c != null) {
                this.dataChanges = JSON.parse(c);
            }
            let d = window.localStorage.getItem(this.tableName);
            if (c != null) {
                this.data = JSON.parse(c);
            }
        }

    }



    saveToSend(event) {
        if (event != null) {
            let x = Object.assign({}, event); // gera copia do objeto 
            if (x.index != null)
                delete x.index;
            if (x.actions != null)
                delete x.actions;
            this.dataChanges.push(x);
        }
        if (this.tableName != null) {
            window.localStorage.setItem(this.tableName + '_changes', JSON.stringify(this.dataChanges));
            window.localStorage.setItem(this.tableName, JSON.stringify(this.data));
        }

    }

    isDataColumn(coluna, row) {
        return ((coluna != "actions"));
    }
    isIcon(item) {
        return item.type === "icon";
    }
    isText(item) {
        return (item.type == null) || (item.type === "text");
    }

    clear() {
        this.displayedColumns = [];
        this.titleColumns = [];
        this.dataSource.data = [];
    }
    hasInfo(item) {
        return item.info != null;// && item.info.length>0;
    }
    getInfo(item){
        return item.info;
    }

    @Input()
    get columns(): Array<DataGridColumn> {
        return this.titleColumns;
    }
    set columns(x: Array<DataGridColumn>) {
        if (x != null) {
            this.titleColumns = [];
            this.displayedColumns = [];
            x.forEach(key => {
                this.addColumnItem(key);
            })
        }
    }

    @Input()
    get values() {
        return this.value;
    }
    set values(x) {
        this.value = x;
    }
    @Input()
    get value() {
        return this.dataSource.data;
    }
    set value(dados: Array<any>) {
        if ((dados != null) && (dados.length > 0)) {
            if (this.columnsCount() == 0) {
                let row = dados[0];
                for (var key in row) {
                    if (key != "index") {
                        this.addColumn(key);
                    }
                }
            }
            if (this.editable) {
                let x = this.displayedColumns.indexOf('actions');
                if (x < 0) { this.addColumn('actions', 'Ações', 1, 1, 'transparent', false) };
            }
            this.maxIndex = -1;
            for (let x = 0; x < dados.length; x++) {
                dados[x].index = x;
                if (x > this.maxIndex) { this.maxIndex = x };
            }
            this.dataOrigem = dados;
            this.data = dados.slice();
            this.refleshData(null);
            if (this.oldPageIndex)
                this.pageIndex = this.oldPageIndex;
            if (this.tableName != null) {
                window.localStorage.setItem(this.tableName, JSON.stringify(this.data));
            }
            this.loaded = true;
        } else {
            if (dados) {
                this.data = dados.slice();
                this.dataOrigem = dados;
                this.refleshData(null);
            }
        }
    }

    refleshData(row) {
        if (row != null) {
            this.data.forEach((r, index) => {
                if (r.index == row.index) {
                    this.data[index] = row;
                }
            });
        }
        this.dataSource.data = this.data;
        this.paginatorShow = (this.fpageSize < this.dataSource.data.length) || this.alwaysShowPaginator;

        this.ref.detectChanges();
    }


    @Input()
    get editing() {
        return this.dataEditing;
    }

    set editing(value) {
        this.dataEditing = value;
        if (!value) {
            this.inEditorLine = false;
        }
    }

    getActions() {
        return 'edit|delete|insert';
    }
    addRowset(row: any) {
        this.dataSource.data.push(row);
    }
    i = 0
    getFieldValue(row, idx) {
        let value: any = row[this.titleColumns[idx].field]
        let col = this.titleColumns[idx], rt = value;
        if (col.type === "number") {
            rt = Number(value);
        }
        if (col.type === "money") {
            rt = Number(value).toLocaleString("pt_br");
        }
        if (typeof value == 'boolean') {
            rt = value ? 'Sim' : 'Não'
        }
        if (col.fn) {
            rt = col.fn(rt);
        }

        return rt;
    }
    getFieldVar(idx) {
        return "row." + this.titleColumns[idx].field;
    }
    getRowIndex(row) {
        return '';
    }
    private capitalizeFirstLetter(str) {
        return str[0].toUpperCase() + str.slice(1);
    }

    addColumn(field: string, text: string = "", cols: number = 1, rows: number = 1, color = 'transparent', visible: boolean = true) {

        return this.addColumnItem({ field: field, text: text, cols: cols, rows: rows, color: color, visible: visible, width: 0 });
    }

    addColumnItem(item: DataGridColumn) {
        if (!item.text || item.text == "") item.text = this.capitalizeFirstLetter(item.field);
        this.titleColumns.push(item);
        this.displayedColumns.push(item.field);
        return item;
    }

    columnsCount() {
        if (this.titleColumns != null) {
            return this.titleColumns.length;
        } else return 0;
    }

    @Output()
    change = new EventEmitter();

    @Output()
    matSortChange = new EventEmitter();

    @Output()
    click = new EventEmitter();

    @Output()
    editItem = new EventEmitter();

    @Output()
    deleteItem = new EventEmitter();

    @Output()
    insertItem = new EventEmitter();

    @Output()
    cancelItem = new EventEmitter();

    @Output()
    postItem = new EventEmitter();

    @Output()
    applyItems = new EventEmitter();

    @Output()
    onDialog = new EventEmitter();

    doDialog(state) {
        let msg = { values: this.currentRow, state: state };
        this.onDialog.emit(msg);
    }

    @Output()
    itemClick = new EventEmitter<any>();


    doSelectedEvent(row) {
        this.itemClick.emit(row);
    }
    hasSelectedEvent() {
        return this.itemClick.observers.length > 0;
    }

    propagateChange = (_: any) => { };

    highlight(row) {
    }

    canShowEditButtons() {
        return (this.inEditorLine);
    }

    doClick(event) {
        let old = this.inEditorLine;
        if (old && !this.editing) {
            this.inEditorLine = false;
        } else {
            this.inEditorLine = true;
        }

        if (!this.inEditorLine) {
            this.click.emit(event);
        }
        this.clicked = !this.clicked;
    }

    doEditItem(event) {
        this.selectedRowIndex = event.index;
        this.editing = true;
        this.editItem.emit(event);
        this.currentRow = event;
        this.currentRow.actions = 'post|cancel';
        if (this.onDialog.observers.length > 0) {
            this.doDialog('dsEdit')
        } else
            this.OpenDialog()
    }
    doAddItem() {
        this.editing = true;
        this.currentRow = {};
        if (this.onDialog.observers.length > 0) {
            this.doDialog('dsInsert')
        } else {
            this.OpenDialog()
        }
    }


    canDelete(row) {
        return this.deleteItem.observers.length > 0;
    }

    doDeleteItem(event) {

        this.selectedRowIndex = -1;
        this.editing = false;
        this.data.forEach((item, index) => {
            if (item.index === event.index) {
                if (this.canDelete(null)) {
                    this.deleteItem.emit(event);
                }
                event.rowstate = "deleted";
                this.saveToSend(event);
                this.data.splice(index, 1);
                this.currentRow = null;
            }
            this.refleshData(null);
        });
    }

    doInsertItem(event) {
        // criar nova linha;
        let row: any = {};
        this.maxIndex = this.maxIndex + 1;
        this.displayedColumns.forEach(r => {
            row[r] = null;
        });
        row['rowstate'] = 'inserted';
        row['index'] = this.maxIndex;
        row['actions'] = 'post|cancel';
        this.insertItem.emit(row);
        this.currentRow = row;
        let tmp
        if (this.data != null) { tmp = this.data.slice(); } else { tmp = [] };
        tmp.push(row);
        this.selectedRowIndex = this.maxIndex;
        this.editing = true;
        this.inEditorLine = true;
        this.dataSource.data = tmp;
        this.ref.detectChanges();
    }
    doCancelAll() {
        this.selectedRowIndex = -1;
        this.editing = false;
        this.inEditorLine = false;
        this.dataChanges = [];
        this.data = this.dataOrigem.slice();
        this.refleshData(null);
    }
    doPostItem(event) {
        this.selectedRowIndex = -1;
        this.postItem.emit(event);
        this.editing = false;
        this.currentRow.actions = '';
        if (event.rowstate == 'inserted') {
            this.data.push(event);
        } else {
            event.rowstate = "modifyORinsert";
        }
        this.saveToSend(event);
        this.refleshData(event);
    }

    doCancelItem(event) {
        this.selectedRowIndex = -1;
        this.cancelItem.emit(event);
        this.editing = false;
        this.currentRow.actions = '';
        this.refleshData(null);
    }
    doApplyItems(event) {
        let x = {
            data: this.dataChanges,
            notify: () => {
                this.dataChanges = [];
                this.currentRow = {};
                this.saveToSend(null);
            }
        };
        this.applyItems.emit(x);
    }

    isEditEnabled() {
        return this.editable;
    }

    writeValue(obj: any): void {
        if (obj !== undefined) {
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.registerOnTouched = fn;
    };

    doChange(opt) {
        this.change.emit(this.dataSource.data);
    }


    @Input() set applyFilter(enableOnClient: boolean) {
        if (!enableOnClient) return
        this.inputSearchText = this.inputSearchText;
        this.inputSearchText = this.inputSearchText.toLowerCase();
        this.dataSource.filter = this.inputSearchText;
    }
    doFilter() {
        if (this._enableClientFilter) {
            this.applyFilter = true
        }
        else { //só emite quando fica 900 milisegundos sem digitar                  
            this.emitKeyEventAny(900)
        }
    }
    @Input() set enableClientFilter(value: boolean) {
        if (value != this._enableClientFilter) {
            this._enableClientFilter = value
        }
    }
    get enableClientFilter() {
        return this._enableClientFilter
    }


    emitKeyEventAny(mils: number) {
        let timeOut = () => {
            this.inputKeyUpTimeOutId =
                setTimeout(() => {
                    this.inputKeyUpEnd.emit(this.inputSearchText)
                    this.inputKeyUpTimeOutId = null
                }, mils)
        }
        if (!this.inputKeyUpTimeOutId) {
            timeOut()
        }
        else {
            clearTimeout(this.inputKeyUpTimeOutId)
            timeOut()
        }

    }


    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    sortData(sort: Sort) {
        const data = this.data.slice();
        if (!sort.active || sort.direction == '') {
            this.dataSource.data = data;
            return;
        }
        if (this.matSortChange.observers.length > 0)
            this.matSortChange.emit(sort)
        else {
            let key = sort.active;
            this.dataSource.data = data.sort((a, b) => {
                let isAsc = sort.direction == 'asc';
                let va = a[key], vb = b[key];
                return this.compare(va, vb, isAsc)
            });
        }
    }



    @Input()
    get filtered() {
        return this.dataFilter;
    }
    set filtered(op: boolean) {
        if (op != null) op = true;
        this.dataFilter = op;
    }

    @Input()
    get matSort() {
        return this.dataSorted;
    }
    set matSort(op: boolean) {
        this.dataSorted = (op != null ? true : op);
    }
    isEmpty() {
        return this.dataSource.data.length == 0;
    }
    OpenDialog() {
        let x = Object.assign({}, this.currentRow);
        let dados = {
            columns: this.titleColumns,
            dados: x
        };
        let dialogRef = this.dialog.open(MatDataGridDialog, {
            height: '500px',
            width: '600px',
            data: dados
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                this.currentRow = result;
                this.doPostItem(result);
            } else {
                this.doCancelItem(this.currentRow);
            }
        });

    }
    //-------------------------------//
    //  (checkFilter)
    //-------------------------------// 
    hasCheckFilter() {
        return this.checkFilter.observers.length > 0;
    }
    @Input()
    get checkFilterValue() {
        return this.localCheckFilter;
    }
    set checkFilterValue(x: boolean) {
        this.localCheckFilter = x;
        this.checkFilter.emit(this.localCheckFilter);
    };
    doCheckFilter($event) {
        this.checkFilterValue = $event.checked;
    }

}



@Component({
    selector: 'mat-datagrid-editor',
    template: `
    <mat-card fxFlex>
       <mat-card-title>
         Alteração
       </mat-card-title>
       <mat-card-content fxFlex fxLayout="column">
       <form  #f (ngSubmit)="onSubmit(f.value)">
       <div *ngFor="let item of columns">
       <mat-form-field *ngIf="item.visible">
          <input matInput width="{{(item.width>0?item.width:220)}}"
            name="currentRow_{{item.field}}" 
            value="{{dados[item.field]}}"
            placeholder={{item.text}} /> 
         </mat-form-field>
       </div>
       </form>
       </mat-card-content>
       <mat-card-actions>
       <button mat-button (click)="onSubmit(f.value)">Ok</button>
       <button mat-button (click)="closeClick()">Fechar</button>
       </mat-card-actions>
    </mat-card>`
})
export class MatDataGridDialog {
    columns: Array<DataGridColumn>;
    dados: any = {};
    constructor(
        public dialogRef: MatDialogRef<MatDataGridDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.columns = data.columns;
        this.dados = data.dados;
    }
    ngOnInit() { }

    closeClick(): void {
        this.dialogRef.close(null)
    }
    onSubmit(f) {
        this.dialogRef.close(this.dados);
    }
}

export class MatPaginatorIntlBr extends MatPaginatorIntl {
    nextPageLabel = 'próxima página'
    previousPageLabel = 'página anterior'
    itemsPerPageLabel = 'Itens por página:'

    getRangeLabel = function (page, pageSize, length) {

        return `página: ${page + 1}`

    }
}

